import { useTranslation } from 'react-i18next';
import { Chip, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Menu } from '../types';

interface ServicePeriodsTabProps {
  menu: Menu;
}

const ServicePeriodsTab = ({ menu }: ServicePeriodsTabProps) => {
  const { t } = useTranslation('menus');

  if (menu.servicePeriods.length === 0) {
    return (
      <Paper variant="outlined"
        sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          {t('noServicePeriods', 'No service periods have been configured for this menu.')}
        </Typography>
      </Paper>
    );
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('name', 'Name')}</TableCell>
            <TableCell>{t('startTime', 'Start')}</TableCell>
            <TableCell>{t('endTime', 'End')}</TableCell>
            <TableCell>{t('days', 'Days')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {menu.servicePeriods.map((period) => (
            <TableRow key={period.name}>
              <TableCell>{period.name}</TableCell>
              <TableCell>{period.startTime}</TableCell>
              <TableCell>{period.endTime}</TableCell>
              <TableCell>
                <Stack direction="row"
                  spacing={1}
                  flexWrap="wrap">
                  {period.days.map((day) => (
                    <Chip key={day}
                      label={day}
                      size="small" />
                  ))}
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ServicePeriodsTab;
